module.exports = __webpack_public_path__ + "static/images/pass-card-tip.cf3083f.gif";